import { addPaletteThemeEntry, addTextThemeEntry, addBrushPaletteThemeEntry } from "igniteui-react-core";
import { FontDefaults } from "igniteui-react-core";
var defaultFont = "\"Titillium Web\", Verdana, Arial, sans-serif";
export var DataChartStylingDefaults = /*@__PURE__*/ (function () {
    var DataChartStylingDefaults = {
        "ui-chart-category-axis-tick": {
            "height": "5px",
            "color": "rgba(102, 102, 102, 0.2470)"
        },
        "ui-chart-area-fill-opacity": {
            "opacity": "0.7"
        },
        "ui-chart-aligned-gridlines": {
            "visibility": "visible"
        },
        "ui-chart-axis-stroke": {
            /* transparent is treated as auto */
            "border-top-color": "transparent"
        },
        "ui-chart-axis-major-line": {
            /* transparent is treated as auto */
            "border-top-color": "transparent"
        },
        "font-family": FontDefaults.chartFontFamily,
        "font-style": "normal",
        "font-weight": "normal",
        "font-size": FontDefaults.chartFontSize + "px",
        "color": FontDefaults.chartAxisLabelBrush.fill,
        "font-variant": "",
        "line-height": "",
        "default-font-height": 13
    };
    addPaletteThemeEntry(DataChartStylingDefaults, "ui-chart-axis", null, "rgba(102, 102, 102, 0.2470)");
    addTextThemeEntry(DataChartStylingDefaults, "ui-chart-title", defaultFont, "16px", "#666", "0px", "0px", "0px", "5px");
    addTextThemeEntry(DataChartStylingDefaults, "ui-chart-subtitle", defaultFont, "11px", "#666", "0px", "0px", "0px", "5px");
    addTextThemeEntry(DataChartStylingDefaults, "ui-chart-horizontal-axis-title", FontDefaults.chartFontFamily, FontDefaults.chartFontSize + "px", FontDefaults.chartAxisLabelBrush.fill, "0px", "0px", "0px", "5px");
    addTextThemeEntry(DataChartStylingDefaults, "ui-chart-vertical-axis-title", FontDefaults.chartFontFamily, FontDefaults.chartFontSize + "px", FontDefaults.chartAxisLabelBrush.fill, "0px", "0px", "5px", "0px");
    addTextThemeEntry(DataChartStylingDefaults, "ui-horizontal-axis-labels", FontDefaults.chartFontFamily, FontDefaults.chartFontSize + "px", FontDefaults.chartAxisLabelBrush.fill, "0px", "5px", "0px", "5px", null, "top");
    addTextThemeEntry(DataChartStylingDefaults, "ui-vertical-axis-labels", FontDefaults.chartFontFamily, FontDefaults.chartFontSize + "px", FontDefaults.chartAxisLabelBrush.fill, "5px", "0px", "5px", "0px", "right");
    addTextThemeEntry(DataChartStylingDefaults, "ui-angular-axis-labels", FontDefaults.chartFontFamily, FontDefaults.chartFontSize + "px", FontDefaults.chartAxisLabelBrush.fill, "5px", "5px", "5px", "5px");
    addTextThemeEntry(DataChartStylingDefaults, "ui-radial-axis-labels", FontDefaults.chartFontFamily, FontDefaults.chartFontSize + "px", FontDefaults.chartAxisLabelBrush.fill, "0px", "5px", "0px", "5px", null, "top");
    addTextThemeEntry(DataChartStylingDefaults, "ui-funnel-slice", defaultFont, "12px", "#666", "0px", "5px", "0px", "5px", null, "top");
    addBrushPaletteThemeEntry(DataChartStylingDefaults, "ui-chart-palette", ["#8BDC5C", "#8961A9", "#6DB1FF", "#82E9D9", "#EA3C63", "#735656", "#F8CE4F", "#A8A8B7", "#E051A9", "#FF903B"], null);
    addBrushPaletteThemeEntry(DataChartStylingDefaults, "ui-chart-marker-palette", ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"], ["#8BDC5C", "#8961A9", "#6DB1FF", "#82E9D9", "#EA3C63", "#735656", "#F8CE4F", "#A8A8B7", "#E051A9", "#FF903B"]);
    return DataChartStylingDefaults;
})();
